import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import enHome from './locales/en/home.json';
import enSetting from './locales/en/setting.json';
import koHome from './locales/ko/home.json';
import koSetting from './locales/ko/setting.json';
import jaHome from './locales/jp/home.json';
import jaSetting from './locales/jp/setting.json';

i18n
  .use(LanguageDetector) // Automatically detect user's language preference
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources: {
      en: {
        home: enHome,
        setting: enSetting,
      },
      ko: {
        home: koHome,
        setting: koSetting,
      },
      jp: {
        home: jaHome,
        setting: jaSetting,
      },
    },
    fallbackLng: 'ko', // Default language
    ns: ['home', 'setting', 'homepage'], // Add 'setting' and 'homepage' here
    defaultNS: 'home', // Default namespace
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;
